import { Radio, RadioGroup } from '@nextui-org/react'
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form'

import type { ControlledRadioGroupProps } from '../type'

export function ControlledRadioGroup<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  fieldProps,
  name,
  options,
  rules,
}: Readonly<ControlledRadioGroupProps<TFieldValues, TName>>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error, invalid },
      }) => (
        <RadioGroup
          errorMessage={error?.message}
          isInvalid={invalid}
          isRequired={rules?.required as boolean}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...fieldProps}
        >
          {options.map((item) => (
            <Radio key={item.value} value={item.value}>
              {item.label}
            </Radio>
          ))}
        </RadioGroup>
      )}
      rules={rules}
    />
  )
}

export default ControlledRadioGroup
